module.exports = __webpack_public_path__ + "img/frame (120).ceb60f19.jpg";